import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { TitleCaptionText } from "components/slices";
import { withStyles } from "@material-ui/styles";
import { ButtonOutlineLight } from "components/ui";
import linkResolver from "utils/linkResolver";

const styles = {
  image: {
    maxWidth: "100%"
  },
  overlay: {
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  }
};

function ImageRightTextLeft(props) {
  const { primary, classes } = props;
  return (
    <Container maxWidth={false}>
      <Grid container alignItems="center">
        <Box
          component={Grid}
          item
          xs={12}
          md={6}
          order={{ xs: 2, md: 1 }}
          position="relative"
        >
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.3)"
              }}
            />
            <img
              className={classes.image}
              src={primary.image.url}
              alt={primary.image.alt}
            />
          </div>
          <Box
            position="absolute"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
            className={classes.overlay}
            p={4}
          >
            <Box />
            <Box>
              {primary.image_title && (
                <Typography component="p" variant="h4" color="secondary">
                  {primary.image_title[0].text}
                </Typography>
              )}
            </Box>
            <Box>
              {primary.image_link_title && primary.image_link && (
                <ButtonOutlineLight
                  text={primary.image_link_title[0].text}
                  link={`${
                    primary.image_link._meta
                      ? linkResolver(primary.image_link._meta)
                      : "/"
                  }`}
                />
              )}
            </Box>
          </Box>
        </Box>
        <Box component={Grid} item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Box px={[0, 2, 2, 16]}>
            <TitleCaptionText
              data={primary}
              titlecomponent="h4"
              xs={12}
              md={12}
              lg={12}
            />
          </Box>
        </Box>
      </Grid>
    </Container>
  );
}

ImageRightTextLeft.propTypes = {
  primary: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ImageRightTextLeft);
